import React from 'react';
import { Modal } from 'antd';
import InfoCircle from '@/assets/icons/info-circle.svg';

type ModalVariant = 'confirm' | 'danger';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  variant?: ModalVariant;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  title = '確認ダイアログ',
  message,
  variant = 'confirm',
  confirmText = 'はい',
  cancelText = 'いいえ',
  loading = false,
}) => {
  const isDanger = variant === 'danger';
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={true}
      centered
      width={540}
      className={`confirm-modal ${isDanger ? 'confirm-modal-danger' : 'confirm-modal-primary'}`}
    >
      <div className="confirm-modal-content">
        <div className="confirm-modal-header">
          <img
            src={InfoCircle}
            alt="info"
            className={`confirm-modal-icon ${isDanger ? 'danger' : 'primary'}`}
            width={28}
            height={28}
          />
          <span className="confirm-modal-title">{title}</span>
        </div>
        <div className="confirm-modal-body">
          <p className="confirm-modal-message">{message}</p>
        </div>
        <div className="confirm-modal-footer">
          <button
            type="button"
            className="confirm-modal-btn cancel"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className="confirm-modal-btn confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? '処理中...' : confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;

